// extracted by mini-css-extract-plugin
export default {"component":"p9dpz"};